module.exports = __webpack_public_path__ + "img/equipment2.7d030c3e.svg";